<template>
  <div
    :class="{
      'sidebar-header': true,
      'sidebar-header--collapsed': isCollapsed,
    }"
  >
    <div class="sidebar-header__inner">
      <div class="partner-logo-container">
        <svg-icon v-if="isCollapsed" icon-class="partner-logo" />
        <svg-icon
          v-else
          :icon-class="tamaraBusinessLogo"
          width="141px"
          height="16px"
          color="#fff"
        />
      </div>
      <div v-if="collapseButtonVisible" class="controller-button">
        <svg-icon
          :icon-class="sidebarControllerButtonName"
          @click="handleToggleSidebar"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SidebarHeader',
  props: {
    currentLocale: {
      type: String,
      required: true,
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    collapseButtonVisible: {
      type: Boolean,
      default: true,
    },
    isRightToLeftDirection: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tamaraBusinessLogo() {
      return this.currentLocale === 'en_US'
        ? 'partner-business-logo-en'
        : 'partner-business-logo-ar'
    },
    sidebarControllerButtonName() {
      if (this.isRightToLeftDirection) {
        return this.isCollapsed ? 'collapse-icon-active' : 'collapse-icon'
      }

      return this.isCollapsed ? 'collapse-icon' : 'collapse-icon-active'
    },
  },
  methods: {
    handleToggleSidebar() {
      const event = this.isCollapsed ? 'click:expand' : 'click:collapse'

      this.$emit(event)
    },
  },
}
</script>

<style lang="scss" scoped>
.sidebar-header {
  line-height: 29px;

  &--collapsed {
    color: var(--tamara-color-content-inverted);
  }

  &__inner {
    display: flex;
    align-items: center;
    height: 20px;
    font-size: 22px;
    font-weight: 700;
    line-height: 29px;

    .partner-logo-container {
      position: relative;
      display: flex;
      gap: 8px;
      align-items: center;
      margin-inline-end: auto;

      .partner-text {
        flex: 1 1 auto;
      }

      .ramadan-logo-decorator {
        position: absolute;
        top: -14px;
        right: -16px;

        [dir='rtl'] & {
          top: -14px;
          right: auto;
          left: 4px;
        }
      }
    }

    .controller-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      padding: 4px;
      font-size: 16px;
      color: var(--tamara-color-background-bright);
      cursor: pointer;
      background-color: transparent;
      border-radius: 6px;
      transition: all 0.3s linear;

      &:hover {
        color: #fff !important;
        background-color: #8901dd !important;
        transition: all 0.3s linear;
      }
    }
  }
}
</style>
